import { useBotEndpoint } from "../_actions/bot";

export const useExecuteTool = (tool_id, onSuccess) => {
    return useBotEndpoint(`/ai_toolbox/execute/${tool_id}`, onSuccess);
};
